import React from 'react'
import {
  EnquiryStatuses,
  IEnquiryPreLodgementResponse,
} from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'

export interface IEnquiryLodgementWizardHeading {
  pageHeading: string
  step: number
  preLodgementData: IEnquiryPreLodgementResponse
}

const EnquiryLodgementWizardHeading = (
  props: IEnquiryLodgementWizardHeading
) => {
  return (
    <>
      <Conditional
        if={
          props.step == 0 &&
          props.preLodgementData?.enquiryStatus.toLocaleLowerCase() ===
            EnquiryStatuses.EnquirySaved.toLocaleLowerCase()
        }
      >
        <h1>{props.pageHeading}</h1>
      </Conditional>
      <Conditional
        if={
          props.step == 0 &&
          props.preLodgementData?.enquiryStatus.toLocaleLowerCase() ===
            EnquiryStatuses.EnquiryOpen.toLocaleLowerCase()
        }
      >
        <h1>{props.pageHeading}</h1>
      </Conditional>
      <Conditional if={props.step > 0}>
        <h1>{props.pageHeading}</h1>
      </Conditional>
    </>
  )
}

export default EnquiryLodgementWizardHeading
